import React from "react";
import { Link } from "react-router-dom";

const PersonalInfoPolicy = () => {
  const content = `개인위치정보 처리방침 등에 관한 사항

제1조【개인위치정보 처리방침】
① 주식회사 마이즈(이하 “회사”라고 합니다) 이용자의 동의를 기반으로 개인위치정보를 수집・이용・제공하고 있으며, 이용자의 권리(개인정보 자기결정권)를 적극적으로 보장합니다.
② 회사는 위치정보이용서비스제공자가 준수하여야 하는 대한민국의 관계 법령 및 개인위치정보 보호 규정, 가이드라인을 준수하고 있습니다. 「개인위치정보 처리방침」이란 이용자의 소중한 위치정보를 보호함으로써 이용자가 안심하고 서비스를 이용할 수 있도록 준수해야할 지침을 의미합니다.
③ 본 「개인위치정보 처리방침」은 스마트통합관리시스템 서비스(이하 “서비스”라고 합니다)에 적용됩니다.

제2조【개인위치정보 처리목적 및 보유기간】
회사는 개인위치정보 및 위치기반서비스 이용약관에서 정한 목적 범위 내에서 개인위치정보를 수집・이용・제공하며, 서비스의 이용 목적 달성을 위해 서비스 탈퇴시 까지 보관합니다. 다만, 법령에 따른 개인위치정보주체의 권리를 행사하는 경우 해당 요청에 따라 처리방침에 의거 파기 절차를 진행합니다.

제3조【개인위치정보 수집・이용・제공사실 확인자료 보유근거 및 보유기간】
회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제16조 제2항에 근거하여 개인위치정보주체에 대한 위치정보 수집・이용・제공사실 확인자료를 위치정보시스템에 자동으로 기록하며, 6개월 이상 보관합니다.

제4조【개인위치정보의 제3자 제공】
① 회사는 원칙적으로 개인위치정보주체의 개인위치정보를 수집・이용・제공 목적으로 명시한 범위 내에서 처리하며, 다음의 경우를 제외하고는 사전 동의 없이는 정한 목적 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다.
1. 개인위치정보주체로부터 별도의 동의를 받은 경우
2. 서비스의 제공에 따른 요금정산을 위해 위치정보 수집・이용・제공사실 확인자료가 필요한 경우
3. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
4. 그 밖에 「위치정보의 보호 및 이용 등에 관한 법률」 등 관련 법령에서 정한 경우
② 회사는 개인위치정보를 개인위치정보주체가 지정하는 제3자에게 제공한 서비스를 하고자 하는 경우에는 제공받는 자 및 제공목적을 개인위치정보주체에게 고지하고 동의를 얻어야 합니다.
③ 제2항에 따라 제3자에게 위치정보를 제공한 경우에는 개인위치정보주체가 사전에 지정한 단말기의 SMS 또는 E-mail로 즉시 통합니다.
④ 단, 아래 각 호에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신단말장치 또는 전자우편주소 등으로 통보합니다.1. 개인위치정보를 수집한 해당 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우2. 회원이 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우⑤ 제3항에도 불구하고 회원은 위치정보법 시행령 제24조에 따라 정보제공내역을 (10일마다 또는 10회씩) 모아서 통보받는 방법을 선택할 수 있으며, 회원이 회사의 절차에 따라 요청할 경우 전항에 따른 즉시 통보 방법으로 변경할 수 있습니다.⑥ 회원은 제1항·제2항·제5항에 따른 동의를 하는 경우 이용·제공목적, 제공받는 자의 범위 및 위치기반서비스 이용약관의 내용 중 일부와 회원의 개인위치정보에 대한 제3자 제공의 경우 통보방법에 대하여 동의를 유보할 수 있습니다.

제5조【개인위치정보처리의 위탁】
개인위치정보 처리를 위탁하는 경우 관련 사항은 관련 홈페이지에 게재하여 정보 주체가 확인할 수 있도록 안내하고 있으며, 회사는 별도의 위탁 사항이 없음을 알려드립니다.

제6조【개인위치정보주체의 권리】
① 개인위치정보주체는 언제든지 위치정보 수집 및 이용・제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다.
② 개인위치정보주체는 언제든지 개인위치정보의 수집 및 이용・제공의 일시적인 중지를 요구할 수 있습니다. 이 경우 회사는 요구를 거절하지 아니하며, 이를 위한 기술적 수단을 갖추고 있습니다.
③ 개인위치정보주체는 회사에 대하여 아래 자료의 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 이유 없이 요구를 거절하지 아니합니다.
1. 개인위치정보주체에 대한 위치정보 수집・이용・제공사실 확인자료
2. 개인위치정보주체의 개인위치정보가 「위치정보의 보호 및 이용 등에 관한 법률」 또는 다른 법률의 규정에 의하여 제3자에게 제공된 이유 및 내용
④ 회사는 개인위치정보주체가 위치정보 수집 및 이용・제공에 대한 동의의 전부 또는 일부를 철회한 경우에는 지체 없이 수집된 개인위치정보 및 위치정보 수집 및 이용・제공사실 확인자료(동의의 일부를 철회한 경우에는 철회하는 부분의 개인위치정보에 한 한다)를 파기합니다.
⑤ 개인위치정보주체는 제 1항 내지 제 4항의 권리행사를 위해 E-mail, 전화, 방문 등을 통해 회사에 요구할 수 있습니다.
⑥ 개인정보주체의가 개인위치정보의 오류 등에 대한 정정 또는 삭제 등을 요구한 경우에는 회사는 정정 또는 삭제 등을 완료할 때까지 서비스가 제한될 수 있으며 개인위치정보를 이용하거나 제공하지 않습니다.

제7조【보호의무자의 권리의무와 그 행사방법】
①  회사는 아래의 경우에 해당하는 이용자(이하 “8세 이하의 아동 등”이라 합니다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공을 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
1. 8세 이하의 아동
2. 피성년후견인
3. 장애인복지법 제2조 제2항 제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진 및 직업재활법 제2조 제2항의 규정에 의한 중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 사람에 한정)
② 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보를 수집・이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다. 보호의무자는 8세 이하의 아동 등의 개인위치정보 수집・이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.

제8조【법정대리인등을 통한 권리 행사방법】
개인정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 개인정보주체의 권리를 행사할 수 있으며, 이 경우 「개인정보보호법 시행규칙」 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.

제9조【개인위치정보의 파기 절차 및 방법】
① 회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제24조제4항에 근거하여 개인위치정보주체가 동의의 전부 또는 일부를 철회한 경우에는 지체 없이 수집된 개인위치정보 및 위치정보 수집・이용・제공사실 확인자료(동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보수집 수집 및 이용・제공사실 확인자료에 한 합니다)를 복구 및 재생이 불가능한 방법으로 파기합니다.
② 회사는 개인위치정보주체의 위치정보 수집 및 이용목적을 달성하거나, 개인위치정보주체가 위치정보의 수집에 대한 동의의 전부 또는 일부에 대하여 철회한 때에는 「위치정보의 보호 및 이용 등에 관한 법률」 제16조제2항의 규정에 근거하여 기록, 보존하여야 하는 위치정보의 수집 및 이용・제공사실 확인자료 외의 당해 개인위치정보를 복구 및 재생이 불가능한 방법으로 지체 없이 파기합니다.

제10조【개인위치정보의 보호조치에 관한 사항】
회사는 개인위치정보 보호에 대한 회사정책 및 「위치정보의 보호 및 이용 등에 관한 법률」 제16조에 근거하여 개인위치정보주체의 위치정보를 보호하며, 개인위치정보보호를 위한 적합한 아래와 같이 보안조치를 취합니다.
① 내부관리계획 수립 및 시행
② 개인위치정보 암호화
③ 해킹 등에 대한 기술적 대책
④ 개인위치정보처리시스템 접근제한 및 식별인증절차
⑤ 접속기록 보관 및 위・변조 방지
⑥ 개인위치정보 취급 직원의 최소화 및 정기교육
⑦ 주기적인 내부감사 및 관리적 보호조치

제11조【개인위치정보보호 담당】
회사는 이용자의 개인위치정보를 보호하고 발생한 모든 개인위치정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 위치정보 관리책임자 및 고객센터로 문의하실 수 있습니다. 회사는 이용자의 신고사항에 대해 신속하게 충분한 답변 및 처리 할 것입니다.

① 본 약관에 따라 서비스를 제공하는 회사의 정보는 아래와 같습니다.
- 상호 : 주식회사 마이즈
- 주소 : 인천광여시 연수구 컨벤시아대로165, 포스코타워-송도 27층

② 회사는 개인위치정보의 보호 및 개인위치정보주체의 불만사항을 원활히 처리하기 위하여 
위치정보관리책임자를 지정 및 운영하고 있으며, 관련 정보는 아래와 같습니다.
- 위치정보관리책임자 : 김혜진 이사 (개인정보 보호책임자 겸직)
- 전화번호 : 1670-6640
- E-mail : mizeinc@mizecompany.co.kr

제12조【개인위치정보주체의 권리 청구방법】
개인위치정보주체는  「위치정보의 보호 및 이용 등에 관한 법률」 제24조에 따른 권리행사를 부서에 할 수 있으며, 회사는 개인위치정보주체의 권리가 신속하게 처리될 수 있도록 하겠습니다.
- 부서명 : CS접수센터
- 전화번호 : 1670-6640
- URL : http://mizecloud-cs.co.kr/ 

제13조【개인위치정보처리방침의 변경】
회사는 법령, 서비스 내용 또는 내부 운영방침의 변경에 따라 개인위치정보 처리방침을 변경할 수 있습니다.
개인위치정보 처리방침이 변경되는 경우 회사는 변경된 내용을 회사의 홈페이지 등 이용자가 확인할 수 있는 방법으로 공개합니다.

개인위치정보처리방침 시행일자 : 2025-07-01`;

  return (
    <div className="terms_page">
      <div className="terms_box">
        <h1 className="terms_title">개인위치정보 처리방침</h1>

        <div className="terms_content">{content}</div>
      </div>
    </div>
  );
};

export default PersonalInfoPolicy;
